import { XStack } from '@/components/ui';

import { AgentProfilePanel, AgentProfilePill } from './agents-profile-panel';
import { AgentThread } from './agents-thread';

type AgentThreadHostProps = {
  threadId: string;
};

export const AgentThreadHost = ({ threadId }: AgentThreadHostProps) => (
  <XStack className="relative min-h-0 min-w-0 flex-1">
    <XStack className="relative min-h-0 min-w-0 flex-1">
      <XStack className="min-h-0 min-w-0 flex-1">
        <AgentThread threadId={threadId} />
      </XStack>
      <AgentProfilePill chatId={threadId} />
    </XStack>
    <AgentProfilePanel chatId={threadId} />
  </XStack>
);
